import { NgModule, ModuleWithProviders } from '@angular/core';
import { AccordionModule } from '@duoduo-oba/ng-devui/accordion';
import { AlertModule } from '@duoduo-oba/ng-devui/alert';
import { AnchorModule } from '@duoduo-oba/ng-devui/anchor';
import { ButtonModule } from '@duoduo-oba/ng-devui/button';
import { CheckBoxModule } from '@duoduo-oba/ng-devui/checkbox';
import { DCommonModule } from '@duoduo-oba/ng-devui/common';
import { DataTableModule } from '@duoduo-oba/ng-devui/data-table';
import { DatepickerModule } from '@duoduo-oba/ng-devui/datepicker';
import { DragDropModule } from '@duoduo-oba/ng-devui/dragdrop';
import { DrawerModule } from '@duoduo-oba/ng-devui/drawer';
import { DropDownModule } from '@duoduo-oba/ng-devui/dropdown';
import { EditableSelectModule } from '@duoduo-oba/ng-devui/editable-select';
import { LoadingModule } from '@duoduo-oba/ng-devui/loading';
import { ModalModule } from '@duoduo-oba/ng-devui/modal';
import { MultiAutoCompleteModule } from '@duoduo-oba/ng-devui/multi-auto-complete';
import { PaginationModule } from '@duoduo-oba/ng-devui/pagination';
import { PanelModule } from '@duoduo-oba/ng-devui/panel';
import { PopoverModule } from '@duoduo-oba/ng-devui/popover';
import { ProgressModule } from '@duoduo-oba/ng-devui/progress';
import { RadioModule } from '@duoduo-oba/ng-devui/radio';
import { SearchModule } from '@duoduo-oba/ng-devui/search';
import { SelectModule } from '@duoduo-oba/ng-devui/select';
import { StatusModule } from '@duoduo-oba/ng-devui/status';
import { StickyModule } from '@duoduo-oba/ng-devui/sticky';
import { TabsModule } from '@duoduo-oba/ng-devui/tabs';
import { TagsModule } from '@duoduo-oba/ng-devui/tags';
import { TagsInputModule } from '@duoduo-oba/ng-devui/tags-input';
import { ToastModule } from '@duoduo-oba/ng-devui/toast';
import { ToggleModule } from '@duoduo-oba/ng-devui/toggle';
import { TooltipModule } from '@duoduo-oba/ng-devui/tooltip';
import { TreeModule } from '@duoduo-oba/ng-devui/tree';
import { UploadModule } from '@duoduo-oba/ng-devui/upload';
import { AutoCompleteModule } from '@duoduo-oba/ng-devui/auto-complete';
import { InputNumberModule } from '@duoduo-oba/ng-devui/input-number';
import { SliderModule } from '@duoduo-oba/ng-devui/slider';
import { TreeSelectModule} from '@duoduo-oba/ng-devui/tree-select';
import {TransferModule} from '@duoduo-oba/ng-devui/transfer';
import { SplitterModule } from '@duoduo-oba/ng-devui/splitter';
import { BreadcrumbModule } from '@duoduo-oba/ng-devui/breadcrumb';
import { RateModule } from '@duoduo-oba/ng-devui/rate';
import { FormModule } from '@duoduo-oba/ng-devui/form';
import { TextInputModule } from '@duoduo-oba/ng-devui/text-input';
import { TextareaModule } from '@duoduo-oba/ng-devui/textarea';
export * from '@duoduo-oba/ng-devui/accordion';
export * from '@duoduo-oba/ng-devui/alert';
export * from '@duoduo-oba/ng-devui/anchor';
export * from '@duoduo-oba/ng-devui/auto-complete';
export * from '@duoduo-oba/ng-devui/button';
export * from '@duoduo-oba/ng-devui/breadcrumb';
export * from '@duoduo-oba/ng-devui/checkbox';
export * from '@duoduo-oba/ng-devui/common';
export * from '@duoduo-oba/ng-devui/data-table';
export * from '@duoduo-oba/ng-devui/datepicker';
export * from '@duoduo-oba/ng-devui/dragdrop';
export * from '@duoduo-oba/ng-devui/drawer';
export * from '@duoduo-oba/ng-devui/dropdown';
export * from '@duoduo-oba/ng-devui/editable-select';
export * from '@duoduo-oba/ng-devui/form';
export * from '@duoduo-oba/ng-devui/loading';
export * from '@duoduo-oba/ng-devui/modal';
export * from '@duoduo-oba/ng-devui/multi-auto-complete';
export * from '@duoduo-oba/ng-devui/pagination';
export * from '@duoduo-oba/ng-devui/panel';
export * from '@duoduo-oba/ng-devui/popover';
export * from '@duoduo-oba/ng-devui/progress';
export * from '@duoduo-oba/ng-devui/radio';
export * from '@duoduo-oba/ng-devui/rate';
export * from '@duoduo-oba/ng-devui/search';
export * from '@duoduo-oba/ng-devui/select';
export * from '@duoduo-oba/ng-devui/status';
export * from '@duoduo-oba/ng-devui/sticky';
export * from '@duoduo-oba/ng-devui/tabs';
export * from '@duoduo-oba/ng-devui/tags';
export * from '@duoduo-oba/ng-devui/tags-input';
export * from '@duoduo-oba/ng-devui/toast';
export * from '@duoduo-oba/ng-devui/toggle';
export * from '@duoduo-oba/ng-devui/tooltip';
export * from '@duoduo-oba/ng-devui/tree';
export * from '@duoduo-oba/ng-devui/upload';
export * from '@duoduo-oba/ng-devui/input-number';
export * from '@duoduo-oba/ng-devui/slider';
export * from '@duoduo-oba/ng-devui/splitter';
export * from '@duoduo-oba/ng-devui/tree-select';
export * from '@duoduo-oba/ng-devui/transfer';
export * from '@duoduo-oba/ng-devui/text-input';
export * from '@duoduo-oba/ng-devui/textarea';
export * from './version';

@NgModule({
  imports: [],
  exports: [
    AccordionModule,
    AlertModule,
    AnchorModule,
    AutoCompleteModule,
    DCommonModule,
    ButtonModule,
    BreadcrumbModule,
    CheckBoxModule,
    DataTableModule,
    DatepickerModule,
    DragDropModule,
    DrawerModule,
    DropDownModule,
    EditableSelectModule,
    FormModule,
    LoadingModule,
    ModalModule,
    MultiAutoCompleteModule,
    PaginationModule,
    PanelModule,
    PopoverModule,
    ProgressModule,
    RadioModule,
    RateModule,
    SearchModule,
    SelectModule,
    StatusModule,
    StickyModule,
    TabsModule,
    TagsModule,
    TagsInputModule,
    ToastModule,
    ToggleModule,
    TooltipModule,
    TreeModule,
    UploadModule,
    InputNumberModule,
    SliderModule,
    SplitterModule,
    TreeSelectModule,
    TransferModule,
    TextInputModule,
    TextareaModule
  ],
  declarations: []
})
export class DevUIModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: DevUIModule,
    };
  }
}
